import React, { useState } from "react";
import SearchableCheckboxList from "./SearchableCheckboxList";

/**
 * A long, customer-like option set to demo the search-on-top behaviour the way
 * the filter sidebar ("Kund") uses it.
 */
const CUSTOMERS = [
	"Lönnens vård- och omsorgsboende",
	"Abborrvägens Förskola",
	"Abeer Alrikabi",
	"Abrahamsbergsskolan",
	"Adipisicing tempor n",
	"Adolf Fredriks Musikklasser",
	"Bromma Gymnasium",
	"Enskede Skola",
	"Farsta Förskolor",
	"Globala Gymnasiet",
	"Hägerstensåsens Skola",
	"Kungsholmens Grundskola",
	"Midsommarkransens Gymnasium",
	"Norra Real",
	"Östermalmsskolan",
	"Södra Latins Gymnasium",
].map((name, i) => ({ value: `c${i}`, label: name }));

const SHORT_OPTIONS = [
	{ value: "open", label: "Öppen" },
	{ value: "booked", label: "Bokad" },
	{ value: "declined", label: "Nekad" },
];

const SearchableCheckboxListExample: React.FC = () => {
	const [longSelected, setLongSelected] = useState<string[]>([]);
	const [shortSelected, setShortSelected] = useState<string[]>([]);

	const toggle = (setter: React.Dispatch<React.SetStateAction<string[]>>) => (value: string) =>
		setter((prev) => (prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]));

	return (
		<div className="max-w-sm space-y-8">
			<div>
				<h3 className="mb-2 text-base font-semibold text-gray-800">Long list — search box shown</h3>
				<p className="mb-3 text-sm text-gray-500">
					Type to filter (diacritics-insensitive — try “lonnens”). When the search narrows the list
					to a single match, press Enter to check it and clear the query.
				</p>
				<SearchableCheckboxList
					options={CUSTOMERS}
					selected={longSelected}
					onToggle={toggle(setLongSelected)}
				/>
				<p className="mt-3 text-xs text-gray-400">Selected: {longSelected.length}</p>
			</div>

			<div>
				<h3 className="mb-2 text-base font-semibold text-gray-800">
					Short list — no search (below threshold)
				</h3>
				<SearchableCheckboxList
					options={SHORT_OPTIONS}
					selected={shortSelected}
					onToggle={toggle(setShortSelected)}
				/>
			</div>

			<div>
				<h3 className="mb-2 text-base font-semibold text-gray-800">
					Forced search via <code>searchThreshold=0</code>
				</h3>
				<SearchableCheckboxList
					options={SHORT_OPTIONS}
					selected={shortSelected}
					onToggle={toggle(setShortSelected)}
					searchThreshold={0}
				/>
			</div>
		</div>
	);
};

export default SearchableCheckboxListExample;
